import { Component, OnInit } from '@angular/core';
import { LoggingService } from '@EfsServices/logging.service';
import { GuardLinkService } from '@EfsServices/guard-link.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSharingService } from '@EfsServices/data-sharing.service';
import { environment } from '@efsEnvironments/environment';
import { PermissionHandlingService } from '@efsShared/services/permission-handling.service';

@Component({
    selector: 'app-special-links-page',
    templateUrl: './special-links-page.component.html',
    styleUrls: ['./special-links-page.component.css'],
    standalone: false
})
export class SpecialLinksPageComponent implements OnInit {

  constructor(
    private loggingService: LoggingService,
    private guardLinkService: GuardLinkService,
    private router: Router,
    private dataSharingService: DataSharingService,
    public permissionHandlingService: PermissionHandlingService,
  ) { }

  ngOnInit() {
  }

  navigateTo(moduleName) { // validate the link and navigate. add any new modules here
    console.log('In NavigateTo Method');
    this.guardLinkService.validateLink().subscribe(() => {
      // this.toggleSearchSI = true;
      // if (moduleName === 'special instructions') {
      //   this.router.navigate(['setup/searchSpecialInstructions']);
      //   this.dataSharingService.shareData('moduleSI');
      // }
      // if (moduleName === 'prehold') {
      //   this.router.navigate(['setup/prehold']);
      //   this.dataSharingService.shareData('modulePH');
      // }
      // if (moduleName === 'delayed mail') {
      //   this.router.navigate(['setup/delayedMail']);
      //   this.dataSharingService.shareData('moduleDM');
      // }
      // if (moduleName === 'production setup') {
      //   console.log('Navigating to production setup');
      //   this.router.navigate(['setup/productionSetup']);
      //   this.dataSharingService.shareData('modulePS');
      // }
      // if (moduleName === 'production method') {
      //   this.router.navigate(['setup/productionMethod']);
      //   this.dataSharingService.shareData('modulePM');
      // }
      // if (moduleName === 'plan template') {
      //     this.router.navigate(['setup/planTemplate']);
      //     this.dataSharingService.shareData('modulePT');
      // }
      // if (moduleName === 'package template') {
      //     this.router.navigate(['setup/packageTemplate']);
      //     this.dataSharingService.shareData('modulePA');
      // }
      // if (moduleName === 'corp setup') {
      //     this.router.navigate(['setup/corpSetup']);
      //     this.dataSharingService.shareData('moduleCS');
      // }
      // if (moduleName === 'corp setup') {
      //     this.router.navigate(['setup/corpSetup']);
      //     this.dataSharingService.shareData('moduleCS');
      // }
      if (moduleName === 'roleAdmin') {
        console.log('Navigating to roleAdmin');
        this.router.navigate(['roleAdmin']);
        this.dataSharingService.shareData('moduleRA');
      }
    });
  }

}
